import script from "./jewel_results_item.vue?vue&type=script&setup=true&lang=js"
export * from "./jewel_results_item.vue?vue&type=script&setup=true&lang=js"

import "./jewel_results_item.vue?vue&type=style&index=0&id=0067319b&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0067319b"]])

export default __exports__